export const PAGE_HELP = {
  login: {
    title: 'Logowanie — jak działa ekran',
    intro: 'Tu wpisujesz nazwę użytkownika i PIN/hasło. Po zalogowaniu portal pamięta sesję i przenosi Cię do właściwej strony.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'pole użytkownika',
          'pole PIN / hasło',
          'przycisk logowania',
        ],
      },
      {
        heading: 'Mechanizm',
        bullets: [
          'logowanie tworzy token sesji dla Twojego konta',
          'po poprawnym logowaniu portal wraca do strony, z której przyszłaś/przyszedłeś',
          'błąd oznacza po prostu brak poprawnych danych albo brak uprawnień do tej instalacji',
        ],
      },
    ],
  },
  'no-access': {
    title: 'Brak dostępu — co to znaczy',
    intro: 'Ten ekran pojawia się, gdy Twoja rola nie ma dostępu do danej sekcji.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'krótka informacja o braku uprawnień',
          'przycisk przejścia do Twoich sprzątań',
        ],
      },
      {
        heading: 'Mechanizm',
        bullets: [
          'portal sprawdza rolę użytkownika na wejściu do chronionej trasy',
          'jeśli rola nie pasuje, zamiast widoku pokazuje ekran odmowy dostępu',
        ],
      },
    ],
  },
  dashboard: {
    title: 'Dashboard — jak to czytać',
    intro: 'To jest kokpit operacyjny. Pokazuje tylko to, co ma znaczenie dziś: stan mieszkania, najbliższy przyjazd, gotowość sprzątania i rozliczenie z Marią.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'status mieszkania i aktualny pobyt',
          'najbliższy check-in z przygotowaniem dla Marii',
          'sygnał gotowości po WhatsApp / Pulse',
          'ile jest jeszcze do zapłaty Marii',
        ],
      },
      {
        heading: 'Jak działa mechanizm',
        bullets: [
          'kafle liczą się z aktualnych danych w bazie, a nie z ręcznych notatek',
          'źródłem są bookings, cleaning_jobs, integracje i rozliczenia',
          'jeśli coś świeci na czerwono, to znaczy że wymaga reakcji, nie tylko podglądu',
        ],
      },
    ],
  },
  nuki: {
    title: 'Nuki — jak czytać ten kokpit',
    intro: 'Ta strona ma być jednym miejscem do kontroli zamka: czy sync działa, kiedy Maria używała dostępu, kiedy był ostatni gość i czy nie ma błędów synchronizacji.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'status NUKIangel i ostatni przebieg synchronizacji',
          'ostatnie użycie przez Marię i ostatnie użycie przez gościa',
          'krótka historia ostatnich zdarzeń dostępu',
          'lista zaplanowanych / aktywnych kodów',
        ],
      },
      {
        heading: 'Jak najlepiej używać Nuki',
        bullets: [
          'kod gościa ma żyć tylko w oknie konkretnej rezerwacji',
          'kod Marii ma być osobny i stały, bez mieszania z gościem',
          'ta strona ma działać jako panel audytu i codziennej kontroli',
          'jeśli widać błąd albo brak wpisu, to znaczy, że warto sprawdzić sync i ostatnią rezerwację',
        ],
      },
    ],
  },
  health: {
    title: 'Health — jak czytać stan portalu',
    intro: 'To jest centralny cockpit zdrowia portalu. W jednym miejscu pokazuje, czy workery działają, czy mają wszystkie potrzebne narzędzia, gdzie stoją kolejki i gdzie system zaczyna wymagać reakcji.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'usługi bazowe: API, baza i magazyn dokumentów',
          'workery i connectorzy z małymi kropkami przy każdym warunku działania',
          'kolejki i alarmy operacyjne',
          'ostatnie sygnały z WhatsApp, Pulse, Booking, Nuki i billingu',
        ],
      },
      {
        heading: 'Mechanizm',
        bullets: [
          'zielona kropka oznacza, że dany warunek jest spełniony; brak zieleni oznacza brak gotowości albo potrzebę reakcji',
          'portal nie pokazuje tylko „worker żyje”, ale też czy ma wejście, token, dane, zapis i brak zatoru',
          'kolejki i zaległe sprzątania są traktowane jako realny sygnał zdrowia systemu, a nie tylko statystyka',
        ],
      },
    ],
  },
  finance: {
    title: 'Finanse — jak czytać historię i szanse cenowe',
    intro: 'Ta strona pokazuje nie tylko bieżący miesiąc, ale też historię przychodów, średnie zarobki, puste dni i powtarzalne okresy, w których warto testować zmianę ceny.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'bieżący wynik miesiąca: przychód, prowizja, koszty i wynik netto',
          'historia przychodu po miesiącach, kwartałach i latach',
          'średni zarobek, średnia liczba pustych dni i zajętość',
          'proste wskazówki, gdzie raczej obniżać cenę, a gdzie jej bronić',
        ],
      },
      {
        heading: 'Mechanizm',
        bullets: [
          'przychód liczy się z realnych danych rezerwacji zapisanych w portalu',
          'puste dni są liczone jako dni bez żadnej aktywnej rezerwacji w analizowanym okresie',
          'okresy do promocji to te z większą liczbą pustych dni lub słabszą zajętością',
          'okresy do podwyżki to te, gdzie zajętość i przychód za zajęty dzień są wyraźnie mocniejsze od reszty',
        ],
      },
    ],
  },

  'reservation-details': {
    title: 'Szczegóły rezerwacji — co oznacza ten ekran',
    intro: 'To jest karta jednej rezerwacji z kompletem danych operacyjnych.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'dane gościa, daty pobytu i numer rezerwacji',
          'notatki, jeśli ktoś dopisał szczegóły',
          'status sprzątania i link do checklisty',
          'powiązane wiadomości, jeśli rezerwacja ma swój wątek',
        ],
      },
      {
        heading: 'Mechanizm',
        bullets: [
          'ekran ładuje jedną rezerwację po numerze / external_id',
          'sprzątanie jest pobierane z powiązanego cleaning_job',
          'to jest widok do sprawdzania i przejścia do kolejnych działań, nie osobny rejestr',
        ],
      },
    ],
  },
  'cleaning-staff': {
    title: 'Sprzątanie — widok Marii',
    intro: 'To jest widok pracy Marii. Ma być prosty: jedno aktywne sprzątanie, jedna checklista, żadnego backlogu do przeklikiwania później.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'jedno sprzątanie „teraz” albo najbliższe następne',
          'checklista krok po kroku',
          'informacja, dla ilu osób trzeba przygotować mieszkanie',
          'przycisk potwierdzenia, że zadanie zostało zauważone',
        ],
      },
      {
        heading: 'Mechanizm',
        bullets: [
          'system pokazuje tylko jedno aktywne sprzątanie do wykonania',
          'pozostałe są blokowane do swojej kolejki',
          'po oznaczeniu checklisty zadanie przechodzi do done',
        ],
      },
    ],
  },
  'cleaning-admin': {
    title: 'Sprzątanie — centrum operacyjne admina',
    intro: 'Widok admina nie pokazuje backlogu jako „kolejki”. Pokazuje alarmy, aktualne sprzątanie i przyszłe terminy.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'alarmy po terminie jako osobny czerwony blok',
          'sprzątanie w toku',
          'najbliższe przyszłe sprzątania',
          'status potwierdzenia od Marii i płatności',
        ],
      },
      {
        heading: 'Mechanizm',
        bullets: [
          'job po terminie jest traktowany jako alarm, nie backlog',
          'acknowledge oznacza, że Maria widziała zadanie',
          'single current action wybiera najwcześniejsze dostępne zadanie do reakcji',
          'gotowość mieszkania musi być domknięta przed kolejnym gościem',
        ],
      },
    ],
  },
  billing: {
    title: 'Rachunki — jak działa wystawianie',
    intro: 'Tu powstają rachunki dla gości. Mateusz wystawia dokumenty na podstawie prośby i danych pobytu.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'lista próśb i wygenerowanych rachunków',
          'numer rachunku, kwota, termin i status płatności',
          'PDF do pobrania i wysłania',
          'formularz nowej prośby o rachunek',
        ],
      },
      {
        heading: 'Mechanizm',
        bullets: [
          'pozycja trafia do kolejki, a potem dostaje numer i dokument PDF',
          'można ją powiązać z konkretną rezerwacją',
          'rachunki wystawia się dopiero, gdy dane są kompletne',
        ],
      },
    ],
  },
  'guest-messages': {
    title: 'Wiadomości gości — jak pracuje Paweł',
    intro: 'To jest baza wiadomości od gości i wynik pracy Pawła, który klasyfikuje wiadomości i łączy je z rezerwacjami.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'pełna lista wiadomości',
          'kategorie i priorytet nadany przez Pawła',
          'pewność klasyfikacji oraz powód decyzji',
          'powiązanie z rezerwacją, jeśli wiadomość da się jednoznacznie przypisać',
        ],
      },
      {
        heading: 'Mechanizm',
        bullets: [
          'Paweł patrzy na treść, kanał i kontekst pobytu',
          'wiadomość z prośbą o rachunek / fakturę trafia dalej do szkicu dla Mateusza',
          'jeśli klasyfikacja nie jest pewna, wiadomość wymaga ludzkiej oceny',
        ],
      },
    ],
  },
  'integrations-import': {
    title: 'Integracje i import — źródła danych',
    intro: 'To panel diagnostyczny. Głównym źródłem operacyjnym jest telefon / Booking Pulse; email działa tylko jako fallback.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'status telefon / Pulse',
          'status importu emaila',
          'logi synchronizacji i błędów',
        ],
      },
      {
        heading: 'Mechanizm',
        bullets: [
          'Pulse/telefon zbiera realne wiadomości i rezerwacje',
          'email działa awaryjnie, gdy brakuje danych albo trzeba uzupełnić ręcznie',
        ],
      },
    ],
  },
  expenses: {
    title: 'Zakupy — jak działa zwrot',
    intro: 'Ta strona służy do wpisywania zakupów, dołączania paragonów i pilnowania zwrotów.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'nowe zakupy i ich opis',
          'załączniki z paragonami',
          'pozycje do zwrotu, do doprecyzowania i archiwum',
          'powiązanie zakupu ze sprzątaniem, jeśli jest potrzebne',
        ],
      },
      {
        heading: 'Mechanizm',
        bullets: [
          'admin widzi pełną listę, staff tylko to, co dotyczy jego pracy',
          'status review decyduje, czy pozycja może być rozliczona',
          'po wypłacie wpis trafia do archiwum',
        ],
      },
    ],
  },
  users: {
    title: 'Użytkownicy — konta i uprawnienia',
    intro: 'Panel admina do zarządzania kontami, rolami i podstawowymi danymi użytkowników.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'nowe konta',
          'lista istniejących użytkowników',
          'rola, język, aktywność i hasło/PIN',
        ],
      },
      {
        heading: 'Mechanizm',
        bullets: [
          'zmiana hasła/PIN wylogowuje poprzednie sesje',
          'role decydują o tym, które podstrony i akcje są dostępne',
        ],
      },
    ],
  },
  agent: {
    title: 'Panel agenta — do czego służy',
    intro: 'To miejsce na rozmowę z agentem, który sprawdza dane portalu i pomaga w operacyjnych decyzjach.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'historia rozmowy',
          'krótki stan agenta',
          'pole do wpisania zadania',
        ],
      },
      {
        heading: 'Mechanizm',
        bullets: [
          'agent korzysta z danych portalu: rezerwacji, sprzątania, zakupów i integracji',
          'jeśli nie ma pewnej odpowiedzi, najpierw pyta Michała na WhatsApp',
          'odpowiedź jest zapisywana w historii, żeby nie znikała po odświeżeniu',
        ],
      },
    ],
  },
  changelog: {
    title: 'Historia zmian — jak to czytać',
    intro: 'Ta strona pokazuje, co już wydano, co jest w planie i jakie pomysły są jeszcze w parkingu.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'wydane wersje',
          'roadmapa kolejnych kroków',
          'pomysły do rozważenia',
        ],
      },
      {
        heading: 'Mechanizm',
        bullets: [
          'lista jest prowadzona ręcznie jako dziennik zmian',
          'kolejność pokazuje, co zostało już zweryfikowane i co ma wejść następne',
        ],
      },
    ],
  },
  'portal-todo': {
    title: 'Pomysły do publicznego launchu — po co ta strona',
    intro: 'To jest kontrolowany parking pomysłów. Nie jest to kolejka zadań produkcyjnych, tylko miejsce na bezpieczne propozycje rozwoju.',
    sections: [
      {
        heading: 'Co się tu znajduje',
        bullets: [
          'pomysły z priorytetem',
          'status: zrobione, następne albo parking',
          'kontekst i cel każdego pomysłu',
        ],
      },
      {
        heading: 'Mechanizm',
        bullets: [
          'najpierw trafiają tu bezpieczne, małe kroki',
          'rzeczy pilne przenosi się do roadmapy albo do konkretnego taska',
        ],
      },
    ],
  },
};

export function getPageHelp(key, context = {}) {
  const entry = PAGE_HELP[key];
  if (!entry) return null;
  if (typeof entry === 'function') return entry(context);
  return entry;
}
